import { Head, usePage } from '@inertiajs/react'
import { createElement } from 'react'

// Controller の inertia_meta（InertiaController#set_meta）で決めた <title> と OGP。
// 初回はサーバーが <head> に出力し（inertia_meta_tags）、画面遷移のあとはここで差し替える。
type MetaTag = { tagName: string; headKey: string; innerContent?: string; [attr: string]: string | undefined }

const ATTRIBUTE_NAMES: Record<string, string> = { httpEquiv: 'httpEquiv', charset: 'charSet' }

export function MetaTags() {
  const meta = (usePage().props._inertia_meta ?? []) as MetaTag[]
  return (
    <Head>
      {meta.map(({ tagName, headKey, innerContent, type: _type, ...attrs }) => {
        const props = Object.fromEntries(Object.entries(attrs).map(([k, v]) => [ATTRIBUTE_NAMES[k] ?? k, v]))
        return createElement(tagName, { key: headKey, 'head-key': headKey, ...props }, innerContent)
      })}
    </Head>
  )
}
